import { ProfileCompletionRing } from "../data-display/ProfileCompletionRing";

export interface OrganizationOverviewHeroProps {
  title?: string;
  subtitle?: string;
  description?: string;
  complete: number;
  total: number;
}

export function OrganizationOverviewHero({
  title = "Organization Profile",
  subtitle = "The foundation for every opportunity Compass generates.",
  description = "Every opportunity pulls from this profile. The more complete the data, the tighter the ROI math and the more confident the recommendations on each brief.",
  complete,
  total,
}: OrganizationOverviewHeroProps) {
  return (
    <div className="flex items-center justify-between gap-8 p-6 px-8 mb-4 rounded-lg border border-(--border-subtle) bg-(--bg-white)">
      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <h1 className="text-[17px] font-bold tracking-[-0.015em] text-(--fg-primary) m-0">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[13.5px] text-(--fg-secondary) leading-[1.55] m-0">
            {subtitle}
          </p>
        )}
        {description && (
          <p className="text-[13px] text-(--fg-secondary) leading-[1.55] max-w-[60ch] m-0">
            {description}
          </p>
        )}
      </div>
      <div className="shrink-0 flex flex-col items-center gap-[10px]">
        <ProfileCompletionRing complete={complete} total={total} size={120} />
      </div>
    </div>
  );
}
